import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/sass/overrides.sass'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#001859',
        secondary: '#1f65b5',
        accent: '#6EA736',
        error: '#b71c1c',
      },
    },
  },
});
